/**
 * The iframe snippet the share window hands out. Kept apart from the window
 * so it can be tested on its own, and so the window stays a component file.
 */

function escapeAttr(value: string): string {
  return value.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

/**
 * The snippet. `ratio` is height over width, so a portrait phone recording
 * gets a tall frame rather than a 16:9 letterbox with the video lost in it.
 */
export function embedCode(src: string, title: string, ratio: number, width: number | null): string {
  const allow = 'allow="autoplay; fullscreen; picture-in-picture; clipboard-write" allowfullscreen';
  const name = `title="${escapeAttr(title)}"`;
  if (width === null) {
    const padding = `${(ratio * 100).toFixed(2)}%`;
    return (
      `<div style="position:relative;padding-bottom:${padding};height:0;">` +
      `<iframe src="${escapeAttr(src)}" frameborder="0" ${allow} ` +
      `style="position:absolute;top:0;left:0;width:100%;height:100%;" ${name}></iframe></div>`
    );
  }
  const height = Math.round(width * ratio);
  return `<iframe src="${escapeAttr(src)}" width="${width}" height="${height}" frameborder="0" ${allow} ${name}></iframe>`;
}
